/**
 * Card entry that works in both surfaces:
 *  - SPA/light DOM: the shared `CardFields` inside a Stripe `<Elements>` provider.
 *  - Embed/shadow root: an in-flow Dorsia-origin iframe (`EmbeddedPaymentHost`),
 *    because Stripe.js refuses to mount Elements inside a shadow root.
 *
 * The `IS_EMBED` branch below is the load-bearing regression guard for the whole
 * payment-iframe architecture: reverting it back to the SPA form would break card
 * entry in the shadow-root embed. `cardEntry.embed.test.tsx` pins this routing.
 */
import { Elements } from '@stripe/react-stripe-js';
import { type Stripe } from '@stripe/stripe-js';

import { IS_EMBED } from '@/lib/isEmbed.ts';
import { STRIPE_OPTIONS } from './CardForm.tsx';
import EmbeddedPaymentHost from './EmbeddedPaymentHost.tsx';
import { SpaCardForm } from './SpaCardForm.tsx';

export function CardEntry({
  stripe,
  onSuccess,
}: {
  stripe: Stripe | null;
  onSuccess: (brand: string, last4: string) => void;
}) {
  if (IS_EMBED) {
    return <EmbeddedPaymentHost onSuccess={onSuccess} />;
  }
  return (
    <Elements stripe={stripe} options={STRIPE_OPTIONS}>
      <SpaCardForm onSuccess={onSuccess} />
    </Elements>
  );
}
